export const walletKeys = {
  all: ['wallet'] as const,
  status: (offeringId: string) => [...walletKeys.all, 'status', offeringId] as const,
}
